import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface CreateCoacheeUiEventParams {
	readonly moduleId?: string;
	readonly context: string;
	readonly userId?: string;
	readonly event: string;
}

@Injectable({ providedIn: 'root' })
export class CreateCoacheeUiEventApiMutation extends ApiMutation<
	void,
	CreateCoacheeUiEventParams
> {
	client = 'statistics';
	document = gql`
		mutation CreateCoacheeUiEvent(
			$moduleId: UUID
			$context: String!
			$userId: UUID
			$event: String!
		) {
			createCoacheeUiEvent(
				moduleId: $moduleId
				context: $context
				userId: $userId
				event: $event
			)
		}
	`;
	method = 'createCoacheeUiEvent';
}
